// extracted by mini-css-extract-plugin
export var container = "index-module--container--5WBLn";
export var frontImage = "index-module--frontImage--1qFx5";
export var frontImageContainer = "index-module--frontImageContainer--qjOK7";
export var gradBorder = "index-module--gradBorder--Au43D";
export var step = "index-module--step--jEzEP";
export var steps = "index-module--steps--u+Ct+";
export var subtext = "index-module--subtext--IgM3A";